export default __webpack_public_path__ + "71a7444f4e18b67297d77d57693b6e6d.png";